import { render, staticRenderFns } from "./InfoBonus.vue?vue&type=template&id=d558ca60&scoped=true"
import script from "./InfoBonus.vue?vue&type=script&lang=js"
export * from "./InfoBonus.vue?vue&type=script&lang=js"
import style0 from "./InfoBonus.vue?vue&type=style&index=0&id=d558ca60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d558ca60",
  null
  
)

export default component.exports